type TagBadgeProps = {
  readonly label: string;
};

export const TagBadge = ({ label }: TagBadgeProps) => (
  <span className="inline-flex rounded-full border border-primary-200 bg-primary-50 px-2.5 py-0.5 text-xs font-medium text-primary-800">
    {label}
  </span>
);
